import { useIsFetching, useQueryClient } from "@tanstack/react-query";

/**
 * Bids are placed on the website, outside this app, so nothing here knows when
 * one appears. Both lists (Dashboard, Init Flight) loaded once and then waited:
 * with the app-wide staleTime and refetchOnWindowFocus off, a pilot who bid
 * after opening VACARS5 did not see the flight until they restarted it
 * (reported 2026-10-04).
 *
 * Now they refresh when the pilot comes back to the window (index.js makes
 * window focus count, not only visibility), every minute while visible, and on
 * the Refresh button.
 */
export const BID_QUERY_OPTIONS = {
  staleTime: 10_000,
  refetchOnWindowFocus: true,
  refetchInterval: 60_000,
};

const BID_KEYS = [["my-bids"], ["dashboard"]];

/** Refetch every bid list, wherever it is shown. */
export function useRefreshBids() {
  const qc = useQueryClient();
  const fetching =
    useIsFetching({ queryKey: BID_KEYS[0] }) + useIsFetching({ queryKey: BID_KEYS[1] });
  const refresh = () =>
    Promise.all(BID_KEYS.map((queryKey) => qc.invalidateQueries({ queryKey })));
  return { refresh, refreshing: fetching > 0 };
}
